"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.App = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var _parseFloat2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/parse-float"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));
var _url = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/url"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _ProjectManager = require("./ProjectManager");
var _controllers = require("../controllers");
var _api = require("../api");
var _classes = require("../classes/");
var _utils = require("../utils/utils");
var _patterns = require("../patterns");
var _ICad = require("../classes/ICad");
var NextApp = /*#__PURE__*/function () {
  function NextApp() {
    (0, _classCallCheck2["default"])(this, NextApp);
    this.onUpdateConfig = null;
    this.config = null;
    this.loaderManager = null;
    this.onICadCallback = function (callbackEvent, data) {
      switch (callbackEvent) {}
    };
    this.loaderManager = new _controllers.LoaderManager();
    this.projectManager = new _ProjectManager.ProjectManager();
    if (typeof window != 'undefined' && (window === null || window === void 0 ? void 0 : window.SH_CadState)) {
      this.iCad = new _ICad.ICad();
    }
    this.urit = new _patterns.UndoableIterator();
    this.urHistory = new _patterns.History();
  }
  (0, _createClass2["default"])(NextApp, [{
    key: "setLoaderManager",
    value: function setLoaderManager(loaderManager) {
      this.loaderManager = loaderManager;
    }
  }, {
    key: "getLoaderManager",
    value: function getLoaderManager() {
      return this.loaderManager;
    }
  }, {
    key: "getICad",
    value: function getICad() {
      return this.iCad;
    }
  }, {
    key: "revalCornerCb",
    value: function revalCornerCb(data) {
      var _this = this;
      var dataX = data.getInstance();
      this.loaderManager.start();
      this.projectManager.evalRow(dataX.row).then(function (res) {
        _this.loaderManager.stop();
        _this.iCad.reEvaluateCornerUnit(dataX.row.uniqueid);
        _this.drawAll(false, false);
      })["catch"](function (err) {
        _this.loaderManager.stop();
        console.error(err);
      });
    }
  }, {
    key: "getLang",
    value: function getLang() {
      return this.translator.getLang();
    }
  }, {
    key: "setLang",
    value: function setLang(langCode) {
      var _this2 = this;
      return new _promise["default"](function (resolve, reject) {
        _this2.translator.setLang(langCode).then(function (res) {
          _controllers.WallCat.loadCatalog(_this2.config.config.pareti).then(function () {
            resolve(res);
          })["catch"](function (err) {
            console.error(err);
            resolve(res);
          });
        })["catch"](function (err) {
          return reject;
        });
      });
    }
  }, {
    key: "setLangFromUser",
    value: function setLangFromUser(user) {
      if (user.userLang && user.userLang.length > 0) {
        return this.setLang(user.userLang);
      } else if (user.shop && user.shop.lang) {
        return this.setLang(user.shop.lang);
      } else if (user.shop && user.shop.country) {
        return this.setLang(user.shop.country);
      } else {
        return this.setLang('en_GB');
      }
    }
  }, {
    key: "drawAll",
    value: function drawAll() {
      var _this3 = this;
      var drawTops = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var centerZoom = arguments.length > 1 ? arguments[1] : undefined;
      var endCb = arguments.length > 2 ? arguments[2] : undefined;
      var afterEnd = function afterEnd() {
        _this3.loaderManager.stop();
        if (endCb) endCb();
      };
      this.iCad.drawAll(drawTops, this.projectManager.getProject(), afterEnd, this.loaderManager.progressWithTotal, centerZoom);
    }
  }, {
    key: "initTranlsator",
    value: function initTranlsator() {
      var transPathName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.translator = new _controllers.Translator(transPathName);
    }
  }, {
    key: "initICad",
    value: function initICad(confJson, callback) {
      var noAntiAlias = confJson.noAntiAlias || false;
      this.iCad.init(confJson, callback, this.getProject(), noAntiAlias);
    }
  }, {
    key: "savePrj",
    value: function () {
      var _savePrj = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(clone, config, isOffer) {
        var _this4 = this;
        var envWall, dataWall;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              envWall = this.iCad.getEnvWallJson();
              dataWall = this.iCad.getCadWrapper().fromWallCadToRows();
              envWall.wallsProject = {
                rows: dataWall.rows
              };
              return _context.abrupt("return", new _promise["default"](function (resolveExt, rejectExt) {
                _this4.projectManager.save(clone, isOffer, config, envWall, dataWall).then(function () {
                  _this4.saveMap2D(_this4.projectManager.getProject(), _this4.projectManager.getProject().map2D).then(resolveExt)["catch"](resolveExt);
                })["catch"](function () {
                  rejectExt;
                });
              }));
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function savePrj(_x, _x2, _x3) {
        return _savePrj.apply(this, arguments);
      }
      return savePrj;
    }()
  }, {
    key: "saveMap2D",
    value: function () {
      var _saveMap2D = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(prj, map2DJSON) {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", new _promise["default"](function (resolve, reject) {
                var urlpic = (map2DJSON === null || map2DJSON === void 0 ? void 0 : map2DJSON.imagePath) ? map2DJSON.imagePath : null;
                var imageName = (map2DJSON === null || map2DJSON === void 0 ? void 0 : map2DJSON.imageName) ? map2DJSON.imageName : null;
                if (map2DJSON.saved == true) {
                  urlpic = null;
                  imageName = null;
                }
                var xhr = new XMLHttpRequest();
                xhr.open("GET", urlpic);
                xhr.responseType = "blob";
                xhr.onload = function () {
                  var blob = xhr.response;
                  var imageToUpload = new File([blob], imageName, {
                    type: 'image/jpeg'
                  });
                  var params = {};
                  params.projectId = prj.id;
                  var filelist = [imageToUpload];
                  for (var i = 0; i < filelist.length; i++) {
                    params[filelist[i].name] = filelist[i];
                  }
                  params.overwriteattach = true;
                  _api.NextApiClient.comHandler("soapupload", params, {
                    responseType: 'blob'
                  }, function (res) {
                    App.getLoaderManager().stop();
                    resolve(null);
                  }, function (err) {
                    if (err.internal_error === 'E05') {} else {
                      console.error(err);
                    }
                    App.getLoaderManager().stop();
                    resolve(null);
                  }, function (evt) {
                    App.getLoaderManager().progressWithTotal(evt.loaded, evt.total);
                  });
                };
                xhr.send();
              }));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function saveMap2D(_x4, _x5) {
        return _saveMap2D.apply(this, arguments);
      }
      return saveMap2D;
    }()
  }, {
    key: "emptyPrj",
    value: function emptyPrj() {
      this.projectManager.emptyProject();
      this.urHistory.reset();
    }
  }, {
    key: "loadProject",
    value: function () {
      var _loadProject = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(prjId) {
        var _this5 = this;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", new _promise["default"](function (resolve, reject) {
                _this5.projectManager.loadPrj(prjId).then(function (project) {
                  _this5.urHistory.reset();
                  _this5.getICad().setProject(project);
                  _this5.getICad().centerZoom();
                  _this5.getICad().forceSelectObjByUniqueid(project.currentrow);
                  _this5.urHistory.saveState(new _controllers.GeneralCadCmd(null, null, project, _this5.getICad(), null));
                  resolve(project);
                })["catch"](reject);
              }));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function loadProject(_x6) {
        return _loadProject.apply(this, arguments);
      }
      return loadProject;
    }()
  }, {
    key: "getProject",
    value: function getProject() {
      return this.projectManager.getProject();
    }
  }, {
    key: "updateEvaluatorRule",
    value: function () {
      var _updateEvaluatorRule = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(rowRuled) {
        var _this6 = this;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.getICad().preUpdateRules();
              return _context4.abrupt("return", new _promise["default"](function (resolve, reject) {
                _this6.projectManager.updateEvaluatorRule(rowRuled).then(function (evalRes) {
                  if (!_this6.projectManager.getProject().isProjectRow(rowRuled.getRow())) {
                    _this6.revaluateAllWalls().then(function (json) {
                      _this6.iCad.afterUpdateRules();
                      resolve(json);
                    })["catch"](function (errjson) {
                      console.error("errore revaluateAllWalls");
                      reject(errjson);
                    });
                  } else {
                    App.iCad.afterUpdateRules();
                    resolve(evalRes);
                  }
                })["catch"](function (err) {
                  reject(err);
                });
              }));
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function updateEvaluatorRule(_x7) {
        return _updateEvaluatorRule.apply(this, arguments);
      }
      return updateEvaluatorRule;
    }()
  }, {
    key: "updateRule",
    value: function () {
      var _updateRule = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(row, rule) {
        var _this7 = this;
        var placerIndex,
          _args5 = arguments;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              placerIndex = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : -1;
              this.getICad().preUpdateRules();
              return _context5.abrupt("return", new _promise["default"](function (resolve, reject) {
                _this7.projectManager.updateRule(row, rule, placerIndex).then(function (evalRes) {
                  if (!_this7.projectManager.getProject().isProjectRow(row)) {
                    _this7.revaluateAllWalls().then(function (json) {
                      _this7.iCad.afterUpdateRules();
                      resolve(json);
                    })["catch"](function (errjson) {
                      console.error("errore revaluateAllWalls");
                      reject(errjson);
                    });
                  } else {
                    App.iCad.afterUpdateRules();
                    resolve(evalRes);
                  }
                })["catch"](function (err) {
                  reject(err);
                });
              }));
            case 3:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function updateRule(_x8, _x9) {
        return _updateRule.apply(this, arguments);
      }
      return updateRule;
    }()
  }, {
    key: "setVariant",
    value: function setVariant(variant, rule, catalog) {
      return this.projectManager.setVariant(variant, rule, catalog);
    }
  }, {
    key: "destroy3D",
    value: function destroy3D() {
      this.iCad.changeHMode(false);
      delete this.iCad.get3D().generalCallback;
      this.iCad.free3DEngine();
    }
  }, {
    key: "addWItem",
    value: function addWItem(row, _ref, endCallback) {
      var _this8 = this;
      var roomHeight = _ref.roomHeight;
      var success = true;
      var codice = row.cod;
      var script = row.script;
      var desc = row.des;
      var regola = row.rule;
      var l = (0, _parseFloat2["default"])(regola["var"]("LUNGHEZZA", "\t"));
      var a = (0, _parseFloat2["default"])(regola["var"]("ALTEZZA", "\t"));
      var p = (0, _parseFloat2["default"])(regola["var"]("PROFONDITA", "\t"));
      var newWalls = this.config.config.newWalls;
      if (newWalls) {
        l = (0, _parseFloat2["default"])(regola["var"]("L", "\t"));
        a = (0, _parseFloat2["default"])(regola["var"]("A", "\t"));
        p = (0, _parseFloat2["default"])(regola["var"]("P", "\t"));
      }
      var hterra = (0, _parseFloat2["default"])(regola["var"]("HTERRA", "\t"));
      var catalog = row.catalog;
      var dragImg = row.dragImg;
      var colonna = false;
      var mustCallback = true;
      switch (row.type) {
        case 0:
          this.iCad.createPreconf(row.script);
          break;
        case 1:
          if (roomHeight !== null) {
            regola = regola.setvar("ALTEZZA", roomHeight, "\t");
            regola = regola.setvar("A", roomHeight, "\t");
          }
          this.iCad.drawwallPRO(2, codice, regola, script, catalog);
          break;
        case 2:
          mustCallback = false;
          if (endCallback) {
            this.evalWallItem(codice, regola, catalog).then(function (json) {
              success = _this8.iCad.createWindowPROSvg(1, codice, regola, script, desc, l, a, p, colonna, hterra, '', catalog, dragImg, json.extraEval);
              endCallback();
            })["catch"](function (json) {
              success = _this8.iCad.createWindowPRO(1, codice, regola, script, desc, l, a, p, colonna, hterra, '', catalog, dragImg);
              endCallback();
            });
          } else {
            success = this.iCad.createWindowPRO(1, codice, regola, script, desc, l, a, p, colonna, hterra, '', catalog, dragImg);
          }
          console.log("Inserted: ", success);
          break;
        case 3:
          this.iCad.startDragFloor(WE_TYPE.FLOOR, codice, regola, script, desc, colonna, hterra, catalog);
          break;
        case 4:
          if (roomHeight !== null) {
            hterra = roomHeight;
            regola = regola.setvar("HTERRA", hterra, "\t");
          }
          this.iCad.startDragFloor(WE_TYPE.CEILINGS, codice, regola, script, desc, colonna, hterra, catalog);
          break;
        case 5:
        case 6:
          break;
        case 7:
          this.evalWallItem(codice, regola, catalog).then(function (json) {
            success = _this8.iCad.createPillar(codice, json.rule.reg, desc, catalog, dragImg, json.extraEval);
          })["catch"](function (err) {
            console.error(err);
          });
          break;
        default:
          console.log('Manage addWItem type: ' + row.type);
      }
      if (mustCallback && endCallback) endCallback();
      return success;
    }
  }, {
    key: "evalWallItem",
    value: function evalWallItem(codice, regola, catalog) {
      return new _promise["default"](function (resolve, reject) {
        var tmpRow = new _classes.ProjectRow(null);
        var success = true;
        tmpRow.uniqueid = -1;
        tmpRow.catalog = catalog;
        tmpRow.cmodel = "";
        tmpRow.neutro = "";
        tmpRow.model = "";
        tmpRow.cod = codice;
        tmpRow.reg = regola;
        var baseRowData = _classes.ProjectRow.getRowData(tmpRow, true);
        _controllers.RowEval._eval3DWallItem(catalog, tmpRow.uniqueid, true, baseRowData, true, false, false).then(function (json) {
          resolve(json);
        })["catch"](function (json) {
          reject(null);
        });
      });
    }
  }, {
    key: "evalDivider",
    value: function () {
      var _evalDivider = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(catalog, rule, divider) {
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", this.projectManager.evalDivider(catalog, rule, divider));
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function evalDivider(_x10, _x11, _x12) {
        return _evalDivider.apply(this, arguments);
      }
      return evalDivider;
    }()
  }, {
    key: "evalCloset",
    value: function () {
      var _evalCloset = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(catalog, row, rule, closetData) {
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", this.projectManager.evalCloset(catalog, row, rule, closetData));
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function evalCloset(_x13, _x14, _x15, _x16) {
        return _evalCloset.apply(this, arguments);
      }
      return evalCloset;
    }()
  }, {
    key: "afterLogin",
    value: function afterLogin() {
      var _this9 = this;
      _controllers.WallCat.getJson(this.config.config.pareti).then(function (json) {
        _this9.iCad.setWallCatalog(_this9.config.config.pareti, json);
      })["catch"](function (err) {
        return console.error(err);
      });
    }
  }, {
    key: "loadGallery",
    value: function () {
      var _loadGallery = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(catalog, cod) {
        var _this10 = this;
        var applyHeaderRule,
          _args8 = arguments;
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              applyHeaderRule = _args8.length > 2 && _args8[2] !== undefined ? _args8[2] : false;
              return _context8.abrupt("return", new _promise["default"](function (resolve, reject) {
                _api.GalleryAPI.galleryLoad(catalog, cod, function (json) {
                  var history = _this10.projectManager.getProject().getLastHistoryEntry();
                  if (applyHeaderRule && json && json.autocompData.autoCompData.boxes && json.autocompData.autoCompData && json.autocompData.autoCompData.boxes) {
                    var jsonRows = json.autocompData.autoCompData.boxes;
                    (0, _forEach["default"])(jsonRows).call(jsonRows, function (r) {
                      r.base.ruleRef.reference.reg += '\t' + history.currentModel.header.replace(/;/g, '\t');
                    });
                  }
                  _this10.projectManager.addGallery(json);
                  _this10.iCad.lockCallbacks(true);
                  _this10.iCad.applyGalleryLayout(json, _this10.projectManager.getProject());
                  _this10.iCad.lockCallbacks(false);
                  if (json) resolve(json);else reject();
                }, reject);
              }));
            case 2:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }));
      function loadGallery(_x17, _x18) {
        return _loadGallery.apply(this, arguments);
      }
      return loadGallery;
    }()
  }, {
    key: "setConfig",
    value: function setConfig(newConfig) {
      this.config = newConfig;
      localStorage['3cad.config'] = (0, _stringify["default"])(this.getConfig());
      if (this.onUpdateConfig) this.onUpdateConfig(this.getConfig());
    }
  }, {
    key: "getConfig",
    value: function getConfig() {
      return this.config;
    }
  }, {
    key: "enableViewMakerPrj",
    value: function () {
      var _enableViewMakerPrj = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(quotesEngine, goToFirst, forceNew) {
        var _this11 = this;
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              return _context9.abrupt("return", new _promise["default"](function (resolve, reject) {
                _this11.getLoaderManager().start();
                _this11.iCad.enableViewMakerProject(_this11.projectManager.getProject(), _utils.loadJson, quotesEngine, goToFirst, forceNew).then(function (json) {
                  _this11.getLoaderManager().stop();
                  resolve(json);
                })["catch"](function (err) {
                  console.error(err);
                });
              }));
            case 1:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }));
      function enableViewMakerPrj(_x19, _x20, _x21) {
        return _enableViewMakerPrj.apply(this, arguments);
      }
      return enableViewMakerPrj;
    }()
  }, {
    key: "enableViewMakerRow",
    value: function () {
      var _enableViewMakerRow = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(row, quotesEngine, goToFirst, forceNew) {
        var _this12 = this;
        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              return _context10.abrupt("return", new _promise["default"](function (resolve, reject) {
                _this12.getLoaderManager().start();
                _this12.iCad.enableViewMakerRow(row, _utils.loadJson, quotesEngine, goToFirst, forceNew).then(function (json) {
                  _this12.getLoaderManager().stop();
                  resolve(json);
                })["catch"](function (err) {
                  console.error(err);
                });
              }));
            case 1:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }));
      function enableViewMakerRow(_x22, _x23, _x24, _x25) {
        return _enableViewMakerRow.apply(this, arguments);
      }
      return enableViewMakerRow;
    }()
  }, {
    key: "downloadPhotoMatchImg",
    value: function () {
      var _downloadPhotoMatchImg = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11(data) {
        return _regenerator["default"].wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              console.warn("Deprecated");
              return _context11.abrupt("return", this.downloadImg(data));
            case 2:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function downloadPhotoMatchImg(_x26) {
        return _downloadPhotoMatchImg.apply(this, arguments);
      }
      return downloadPhotoMatchImg;
    }()
  }, {
    key: "downloadImg",
    value: function () {
      var _downloadImg = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee12(data) {
        var img;
        return _regenerator["default"].wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              if (data != null) {
                img = data.fileName;
                _api.HandlerAPI.download(img, this.projectManager.getProject().id, function (res) {
                  var imageUploaded = new File([res], 'tmp.jpg', {
                    type: 'image/jpeg'
                  });
                  data.urlpic = (_url["default"] ? _url["default"] : webkitURL).createObjectURL(imageUploaded);
                  if (data.callback != null) {
                    data.callback(data);
                  }
                }, function (err) {
                  console.error(err);
                });
              }
              console.log("I am here");
            case 2:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function downloadImg(_x27) {
        return _downloadImg.apply(this, arguments);
      }
      return downloadImg;
    }()
  }, {
    key: "revaluateAllWalls",
    value: function () {
      var _revaluateAllWalls = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee13() {
        var _this13 = this;
        return _regenerator["default"].wrap(function _callee13$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              return _context14.abrupt("return", new _promise["default"](function (resolve, reject) {
                var responseArray = [];
                App.iCad.getCadWrapper().saveWalls();
                _api.CrulesAPI.cadCallBackEvalWallsFromProject(_this13.projectManager.getProject(), function (okJson) {
                  if (okJson.evaluatedRules) {
                    var _context13;
                    (0, _forEach["default"])(_context13 = okJson.evaluatedRules).call(_context13, function (evRes) {
                      var tmpRow = new _classes.ProjectWallRow(new _classes.Eval3D(evRes));
                      responseArray.push(tmpRow);
                    });
                    App.iCad.resolveWallAnswer(responseArray);
                    resolve(okJson);
                  } else {
                    console.warn('evalwall without evaluatedRules');
                    resolve(okJson);
                  }
                }, function (errorJson) {
                  console.error("Critical error evalwalls " + errorJson);
                  resolve(errorJson);
                });
              }));
            case 1:
            case "end":
              return _context14.stop();
          }
        }, _callee13);
      }));
      function revaluateAllWalls() {
        return _revaluateAllWalls.apply(this, arguments);
      }
      return revaluateAllWalls;
    }()
  }], [{
    key: "getInstance",
    value: function getInstance() {
      if (NextApp.instance !== null) return NextApp.instance;else {
        NextApp.instance = new NextApp();
        return NextApp.instance;
      }
    }
  }]);
  return NextApp;
}();
NextApp.instance = null;
window['Next'] = NextApp.getInstance();
var App = NextApp.getInstance();
exports.App = App;
//# sourceMappingURL=App.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/AppManager/App.js
// module id = 994
// module chunks = 142